<template>
  <div>
    <l-map
      :center="[3.6963911, 119.6273442]"
      :zoom="5"
      style="height: 680px"
      :options="mapOptions"
      @map-on-click="mapOnClick()"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <template v-if="geojson">
        <l-choropleth-layer
          :data="reportData"
          :titleKey="titleKey"
          :idKey="idKey"
          :value="value"
          :geojsonIdKey="geojsonIdKey"
          :geojson="geojson"
          :colorScale="colorScale"
          :dose="dose"
          :denom="denom"
          :isDistrict="isDistrict"
        >
          <template slot-scope="props">
            <l-info-control
              :item="props.currentItem"
              :unit="props.unit"
              :title="title"
              placeholder="Hover over a Region"
            />
          </template>
        </l-choropleth-layer>
      </template>
      <Legend />
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LGeoJson } from 'vue2-leaflet'
import InfoControl from '@/view/pages/home/map/InfoControl.vue'
import ReferenceChart from '@/view/pages/home/map/ReferenceChart.vue'
import ChoroplethLayer from '@/view/pages/home/map/ChoroplethLayer.vue'
import Legend from '@/view/pages/home/map/Legend.vue'

export default {
  name: 'map_container',
  props: {
    geojson: Object,
    reportData: null,
    titleKey: null,
    idKey: null,
    geojsonIdKey: null,
    title: null,
    dose: String,
    denom: null,
    isDistrict: Boolean,
  },
  components: {
    LMap,
    LTileLayer,
    'v-geojson': LGeoJson,
    'l-info-control': InfoControl,
    'l-reference-chart': ReferenceChart,
    'l-choropleth-layer': ChoroplethLayer,
    Legend,
  },
  data: function () {
    return {
      colorScale: ['e7d090', 'e9ae7b', 'de7062'],
      value: {
        key: 'capaian_harian',
        metric: '',
      },
      mapOptions: {
        attributionControl: false,
        scrollWheelZoom: false,
      },
      currentStrokeColor: '3d3213',
      url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw',
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    }
  },
  methods: {
    mapOnClick: function () {
      console.log('map-on-click')
      this.$emit('map-on-click')
      // this.$refs.leafmap.mapObject.fitBounds(this.currentUserActivity.bounds)
    },
  },
}
</script>

<style>
#map {
  background-color: #eee;
}
</style>
